import { Component } from "react";
import { connect } from "react-redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TableWithoutPagination from "../../Table/TableWithoutPagination";
import { Button, Checkbox, FormControl, Icon, InputLabel, MenuItem } from "@mui/material";
import { ROLES } from "../../../redux/siteMonitoring/siteMonitoringConstants";
import {
    formatRole,
    setUsersAndRights,
    deleteUserAndRights,
} from "../../../redux/siteMonitoring/siteMonitoringActions";
import { clone } from "../../../utils";
import { throwErrorMessage } from "../../../lib/error_helper";
import SelectWithModal from "../../SelectWithModal/SelectWithModal";
import CustomizedSelect from "../../Input/CustomizedSelect";

class SettingsTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tagRows: [],
            stateRows: [],
            usersRows: [],
            columns: [
                {
                    Header: "Droits utilisateurs",
                    columns: [
                        {
                            Header: "",
                            id: "actions",
                            width: 50,
                            Cell: this.renderButtons.bind(this),
                        },
                        {
                            Header: "Utilisateur",
                            Cell: ({ row }) => {
                                let usersAndRights =
                                    this.props.siteMonitoring.site_supervision_authorized_user_ids.filter(
                                        (u) => !u.deleted > 0
                                    );

                                let currentUserAndRights = usersAndRights[row.index];

                                if (!currentUserAndRights) return null;

                                if (
                                    !this.props.siteMonitoring ||
                                    !this.props.siteMonitoring.site_supervision_authorized_user_ids
                                )
                                    return null;

                                let selectedUser = currentUserAndRights.user_id;

                                return (
                                    <div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding solution-table-row-padding">
                                        <SelectWithModal
                                            inputProps={{
                                                name: "user-" + row.index,
                                                id: "user-" + row.index,
                                            }}
                                            placeholder="Utilisateur"
                                            className="full_size"
                                            disabled={this.props.siteMonitoringDisabled}
                                            value={selectedUser ? selectedUser.id : 0}
                                            name={"user-" + row.index}
                                            id={"user-" + row.index}
                                            label={"Utilisateur"}
                                            onValidate={this.onUserChange.bind(this, row.index)}
                                            options={this.props.allUsers.map((u) => {
                                                return {
                                                    value: u.id,
                                                    label: u.name,
                                                };
                                            })}
                                        />
                                    </div>
                                );
                            },
                        },
                        {
                            Header: "Droits",
                            Cell: ({ row }) => {
                                let usersAndRights =
                                    this.props.siteMonitoring.site_supervision_authorized_user_ids.filter(
                                        (u) => !u.deleted > 0
                                    );
                                let currentUser = usersAndRights[row.index];

                                if (
                                    !currentUser ||
                                    !this.props.siteMonitoring ||
                                    !this.props.siteMonitoring.site_supervision_authorized_user_ids ||
                                    !currentUser
                                )
                                    return null;

                                return (
                                    <div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding solution-table-row-padding">
                                        <FormControl className="row">
                                            <InputLabel id={"rights-label" + row.index}>Droits</InputLabel>
                                            <CustomizedSelect
                                                labelId={"rights-label" + row.index}
                                                id={"rights-" + row.index}
                                                label="Droits"
                                                inputProps={{
                                                    name: "rights-" + row.index,
                                                    id: "rights-" + row.index,
                                                }}
                                                placeholder="Droits"
                                                className="full_size"
                                                onChange={this.onRightsChange.bind(this, row.index)}
                                                disabled={this.props.siteMonitoringDisabled || !currentUser.user_id}
                                                value={currentUser.rights}
                                            >
                                                {ROLES.map((role) => {
                                                    return (
                                                        <MenuItem key={role} value={role}>
                                                            {formatRole(role)}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </CustomizedSelect>
                                        </FormControl>
                                    </div>
                                );
                            },
                        },
                        {
                            Header: "Est employé",
                            Cell: ({ row }) => {
                                let usersAndRights =
                                    this.props.siteMonitoring.site_supervision_authorized_user_ids.filter(
                                        (u) => !u.deleted > 0
                                    );
                                let currentUser = usersAndRights[row.index];

                                if (
                                    !currentUser ||
                                    !this.props.siteMonitoring ||
                                    !this.props.siteMonitoring.site_supervision_authorized_user_ids ||
                                    !currentUser
                                )
                                    return null;

                                return (
                                    <div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding solution-table-row-padding">
                                        <Checkbox
                                            checked={currentUser.is_employee}
                                            className="small-checkbox light-disabled"
                                        />
                                    </div>
                                );
                            },
                        },
                    ],
                },
            ],
        };
    }

    onUserChange(rowIndex, value) {
        let siteMonitoring = clone(this.props.siteMonitoring);
        let usersAndRights = [...siteMonitoring.site_supervision_authorized_user_ids].filter((d) => !d.deleted);

        if (!usersAndRights[rowIndex]) return;

        let selectedUser = this.props.allUsers.find((u) => u.id === value);

        if (!selectedUser) return;

        let userAndRights = clone(usersAndRights[rowIndex]);
        userAndRights.user_id = selectedUser;

        if (
            userAndRights.user_id &&
            usersAndRights.filter((u) => u.user_id).some((uar) => uar.user_id.id === userAndRights.user_id.id)
        ) {
            this.props.throwErrorMessage({
                errorObject: siteMonitoring,
                title: "Erreur",
                message: "Impossible d'assigner plusieurs droits à un utilisateur pour une même affaire",
            });

            return;
        }

        usersAndRights[rowIndex] = userAndRights;
        siteMonitoring.site_supervision_authorized_user_ids = usersAndRights;
        this.props.setUsersAndRights(siteMonitoring, userAndRights, this.props.activeUser);
    }

    onRightsChange(rowIndex, e) {
        let siteMonitoring = clone(this.props.siteMonitoring);
        let usersAndRights = [...siteMonitoring.site_supervision_authorized_user_ids.filter((d) => !d.deleted)];

        if (!usersAndRights[rowIndex]) return;

        usersAndRights[rowIndex].rights = e.target.value;
        siteMonitoring.site_supervision_authorized_user_ids = usersAndRights;
        this.props.setUsersAndRights(siteMonitoring, usersAndRights[rowIndex], this.props.activeUser);
    }

    renderButtons(row) {
        if (!row.row.original.user_id) return <div></div>;

        return (
            <div>
                <Button
                    disabled={this.props.siteMonitoringDisabled}
                    onClick={this.removeUser.bind(this, row)}
                    className="col-lg-12 col-md-12 col-sm-12 col-12 small-btn without-padding without-side-margin"
                    color="primary"
                >
                    <Icon className="small-icon">delete</Icon>
                </Button>
            </div>
        );
    }

    removeUser(elementToDelete) {
        let siteMonitoring = clone(this.props.siteMonitoring);
        let users = [...siteMonitoring.site_supervision_authorized_user_ids.filter((d) => !d.deleted)];

        let indexOfUserToDelete = elementToDelete.row.index;

        if (indexOfUserToDelete !== undefined && indexOfUserToDelete >= 0) {
            users[indexOfUserToDelete].deleted = true;

            siteMonitoring.site_supervision_authorized_user_ids = users;
            this.props.deleteUserAndRights(siteMonitoring, users[indexOfUserToDelete], this.props.activeUser);
        }
    }

    getTableTrProps(row) {
        if (row && row.original.id === 0 && !row.original.deleted) {
            return {
                style: {
                    background: "#E3F2FD",
                },
            };
        } else {
            return {};
        }
    }

    render() {
        return (
            <Card className="col-lg-12 col-md-12 col-sm-12 col-12 card card-margin-top without-side-padding">
                <CardContent className="without-side-padding">
                    <TableWithoutPagination
                        data={this.props.siteMonitoring.site_supervision_authorized_user_ids.filter((u) => !u.deleted)}
                        columns={this.state.columns}
                        minRows={5}
                        getTrProps={this.getTableTrProps.bind(this)}
                        contentEditable
                    />
                </CardContent>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
        activeUser: state.activeUser,
        allUsers: state.users.allUsers,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsersAndRights: (siteMonitoring, userAndRights, user) =>
            dispatch(setUsersAndRights(siteMonitoring, userAndRights, user)),
        deleteUserAndRights: (siteMonitoring, userAndRights, user) =>
            dispatch(deleteUserAndRights(siteMonitoring, userAndRights, user)),
        throwErrorMessage: (options) => dispatch(throwErrorMessage(options)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsTab);
